<!-- ===== CONTENIDO ===== -->

<div class="contenido">

  <h2>ARCHIVO</h2>

  <!-- ===== TABS ===== -->
  <ul class="nav nav-tabs custom-tabs">

    <li><button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">2026</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">2025</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">2024</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">2023</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5">2022</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab6">2021</button></li>

  </ul>

  <!-- ===== CONTENIDO DE TABS ===== -->
  <div class="tab-content box-content">

    <!-- TAB 1 -->
    <div class="tab-pane fade show active" id="tab1">
      

      <ul class="pdf-list">
        <li><a href="assets/archivo/2026/INVENTARIOS DEL EJERCICIO FISCAL 2026.pdf" target="_blank">1.-INVENTARIOS DEL EJERCICIO FISCAL 2026</a></li>
        <li><a href="assets/archivo/2026/CUADRO _GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2026.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2026</a></li>
        <li><a href="assets/archivo/2026/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2026.xlsx" target="_blank"> CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2026 </a></li>
        <li><a href="assets/archivo/2026/INFORME_DEL_PADA_2025.pdf" target="_blank">INFORME DEL PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2025 </a></li>
        <li><a href="assets/archivo/2026/PADA_2026.pdf" target="_blank">PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2026 </a></li>
        <li><a href="assets/archivo/2026/INDICE_DE_EXPEDIENTES_CLASIFICADOS_COMO RESERVADOS.docx" target="_blank">INDICE DE EXPEDIENTES CLASIFICADOS COMO RESERVADOS </a></li>
        <li><a href="assets/archivo/2026/GUIA DE ARCHIVO DOCUMENTAL 2026.pdf" target="_blank">GUÍA DE ARCHIVO DOCUMENTAL 2026</a></li>

        <li><a href="assets/archivo/2026/CALENDARIO_DE_SESIONES_GIA_2026.pptx" target="_blank">CALENDARIO_DE_SESIONES_GIA_2026</a></li>
        <li><a href="assets/archivo/2026/Acta de la 1era Sesion Ordinaria 2026.pdf" target="_blank">Acta de la 1era Sesión Ordinaria 2026</a></li>
        <li><a href="assets/archivo/2026/REGLAS DE OPERACION DEL GRUPO INTERDISCIPLINARIO DE ARCHIVO DEL ITSE.pdf" target="_blank">REGLAS DE OPERACION DEL GRUPO INTERDISCIPLINARIO DE ARCHIVO DEL ITSE</a></li>
        <li><a href="assets/archivo/2026/Acta de la 4ta Sesion Ordinaria 2025.pdf" target="_blank">Acta de la 4ta Sesion Ordinaria 2025</a></li>
        <li><a href="assets/archivo/2026/1ACTA DE INSTALACION DEL GIA DEL ITSE.pdf" target="_blank">1.- ACTA DE INSTALACIÓN DEL GIA DEL ITSE</a></li>

      </ul>

    </div>

    <!-- TAB 2 -->
    <div class="tab-pane fade" id="tab2">
      <ul class="pdf-list">
        <li><a href="assets/archivo/2025/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2025.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2025</a></li>
        <li><a href="assets/archivo/2025/CATALO_DE_DISPOSICION_DOCUMENTAL_2025.xlsx" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2025</a></li>
        <li><a href="assets/archivo/2025/INFORME_DEL_PADA_2024.pdf" target="_blank">INFORME DEL PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2024</a></li>
        <li><a href="assets/archivo/2025/PADA_2025.pdf" target="_blank">PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2025</a></li>
        <li><a href="assets/archivo/2025/INDICE_DE_EXPEDIENTES_CLASIFICADOS_COMO_RESERVADOS.docx" target="_blank">INDICE DE EXPEDIENTES CLASIFICADOS COMO RESERVADOS</a></li>
        <li><a href="assets/archivo/2025/GUIA_DE_ARCHIVO_DOCUMENTAL.pdf" target="_blank">GUÍA DE ARCHIVO DOCUMENTAL</a></li>
        <li><a href="assets/archivo/2025/INVENTARIOS_DOCUMENTALES.pdf" target="_blank">INVENTARIOS DOCUMENTALES</a></li>
        <br><br>
        <li><a href="assets/archivo/2025/ACTA_DE_INSTALACION_DEL_GIA_DEL_ITSE.pdf" target="_blank">ACTA DE INSTALACIÓN DEL GIA DEL ITSE</a></li>
        <li><a href="assets/archivo/2025/CALENDARIO_DE_SESIONES_GIA_2025.pdf" target="_blank">CALENDARIO DE SESIONES GIA 2025</a></li>
        <li><a href="assets/archivo/2025/REGLAS_DE_OPERACION_DEL  GRUPO_INTERDISCIPLINARIO_DE_ARCHIVO_DEL_ITSE.pdf" target="_blank">REGLAS DE OPERACION DEL GRUPO INTERDISCIPLINARIO DE ARCHIVO DEL ITSE</a></li>
        <li><a href="assets/archivo/2025/SO-GIA-ITSE-004-2024.pdf" target="_blank">SO-GIA-ITSE-004-2024</a></li>
        <li><a href="assets/archivo/2025/SO-GIA-ITSE-001-2025.pdf" target="_blank">SO-GIA-ITSE-001-2025</a></li>
        <li><a href="assets/archivo/2025/SO-GIA-ITSE-002-2025.pdf" target="_blank">SO-GIA-ITSE-002-2025</a></li>
        <br>
        <br>
        <p>Actualizacion 2025</p>
        <li><a href="assets/archivo/2025/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2025A.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVÍSTICA 2025</a></li>
        <li><a href="assets/archivo/2025/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2025.xlsx" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTA 2025</a></li>
      </ul>
    </div>

    <!-- TAB 3 -->
    <div class="tab-pane fade" id="tab3">
     

      <ul class="pdf-list">
        <li><a href="assets/archivo/2024/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2024.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2024</a></li>
        <li><a href="assets/archivo/2024/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2024.xlsx" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2024</a></li>
        <li><a href="assets/archivo/2024/INFORME_DE_PADA_2023.pdf" target="_blank">INFORME DEL PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2024</a></li>
        <li><a href="assets/archivo/2024/PROGRAMA_ ANUAL_DE_DESARROLLO_ARCHIVISTICO_PADA_2024.pdf" target="_blank">PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2024</a></li>
        <li><a href="assets/archivo/2024/INDICE_DE_EXPEDIENTES_CLASIFICADOS_COMO_RESERVADOS.docx" target="_blank">INDICE DE EXPEDIENTES CLASIFICADOS COMO RESERVADOS</a></li>
        <li><a href="assets/archivo/2024/GUIA_DE_ARCHIVO_DOCUMENTAL.pdf" target="_blank">GUÍA DE ARCHIVO DOCUMENTAL</a></li>
        <li><a href="assets/archivo/2024/INVENTARIOS_DOCUMENTALES.pdf" target="_blank">INVENTARIOS DOCUMENTALES</a></li>

        <br><br>        <p>ACTUALIZACIÓN 2024</p>
        <li><a href="assets/archivo/2024/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2024_Actualizacion_2024.xlsx" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2024</a></li>
        <li><a href="assets/archivo/2024/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2024-Actualizacion_2024.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2024</a></li>
      </ul>
    </div>

    <!-- TAB 4 -->
    <div class="tab-pane fade" id="tab4">
      

      <ul class="pdf-list">
    <li><a href="assets/archivo/2024/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2023.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2023  </a></li>
     <li><a href="assets/archivo/2024/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2023.xlsx" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2023</a></li>
      <li><a href="assets/archivo/2024/INFORME_DE_CUMPLIMIENTO_PADA_2022.pdf" target="_blank">INFORME DEL PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2022</a></li>
       <li><a href="assets/archivo/2024/PROGRAMA_ANUAL_DE_DESARROLLO_ARCHIVISTICO_PADA_2023.pdf" target="_blank">PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2023</a></li>
        <li><a href="assets/archivo/2024/INDICE_DE_EXPEDIENTES_CLASIFICADOS_COMO_RESERVADOS.docx" target="_blank">INDICE DE EXPEDIENTES CLASIFICADOS COMO RESERVADOS (ENERO-JUNIO)</a></li>
         <li><a href="assets/archivo/2024/INDICE_DE_EXPEDIENTES_CLASIFICADOS_COMO_RESERVADOS_JD.docx" target="_blank">INDICE DE EXPEDIENTES CLASIFICADOS COMO RESERVADOS (JULIO-DICIEMBRE)</a></li>

      </ul>
    </div>

    <!-- TAB 5 -->
    <div class="tab-pane fade" id="tab5">


      <ul class="pdf-list">
        <li><a href="assets/archivo/2022/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2022.xlsx" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2022</a></li>
        <li><a href="assets/archivo/2022/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2022_ULTIMA_MODIFICACION.pdf" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2022</a></li>
        <li><a href="assets/archivo/2022/INFORME_DE_CUMPLIMIENTO_PROGRAMA_ANUAL_DE_DESARROLLO_ARCHIVISTICO_PADA_2021.pdf" target="_blank">INFORME DEL PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2021</a></li>
        <li><a href="assets/archivo/2022/PROGRAMA_ANUAL_DE_DESARROLLO_ARCHIVISTICO_2022.pdf" target="_blank">PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO(PADA) 2022</a></li>
        <br><br>
        <li><a href="assets/archivo/2022/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2022_ULTIMA_MODIFICACION.pdf" target="_blank">CATALOGO DE DISPOSICION DOCUMENTAL 2022 ÚLTIMA MODIFICACIÓN</a></li>
        <li><a href="assets/archivo/2022/CUADRO_GENERAL_DE_CLASIFICACION_ARCHIVISTICA_2022_ULTIMA_MODIFICACION.pdf" target="_blank">CUADRO GENERAL DE CLASIFICACION ARCHIVISTICA 2022 ÚLTIMA MODIFICACIÓN.pdf</a></li>
        <li><a href="assets/archivo/2022/GUIA_SIMPLE_DE_ARCHIVOS.xlsx" target="_blank">GUÍA SIMPLE DE ARCHIVOS</a></li>
        <li><a href="assets/archivo/2022/GUIA_DE_ARCHIVO_DOCUMENTAL.xlsx" target="_blank">GUÍA DE ARCHIVO DOCUMENTAL</a></li>
        <li><a href="assets/archivo/2022/INVENTARIOS_DOCUMENTALES.pdf" target="_blank">INVENTARIOS DOCUMENTALES.pdf</a></li>
      </ul>
    </div>

    <!-- TAB 6 -->
    <div class="tab-pane fade" id="tab6">
      

      <ul class="pdf-list">
        <br>
        <p>INSTRUMENTOS ARCHIVISTICOS</p>
        <li><a href="assets/archivo/2021/CATALOGO_DE_DISPOSICION_DOCUMENTAL_2021.pdf" target="_blank">CATÁLOGO DE DISPOSICIÓN DOCUMENTAL 2021</a></li>
        <li><a href="assets/archivo/2021/CUADRO-GENERAL-DE-CLASIFICACION-ARCHIVISTICA-2021.pdf" target="_blank">CUADRO GENERAL DE CLASIFICACIÓN ARCHIVISTICA 2021</a></li>
        <br><br>
        <p>NORMATIVIDAD</p>
        <li><a href="assets/archivo/2021/LEY-GENERAL-DE-ARCHIVOS.pdf" target="_blank">LEY GENERAL DE ARCHIVOS</a></li>
        <li><a href="assets/archivo/2021/REGLAS-DE-OPERACION-DEL-GRUPO-INTERDISCIPLINARIO-DE-ARCHIVO-DEL-ITSE.pdf" target="_blank">REGLAS DE OPERACIÓN DEL GRUPO INTERDISCIPLINARIO DE ARCHIVO DEL ITSE</a></li>
        <br><br>
      <p>PROGRAMA ANUAL DE DESARROLLO ARCHIVISTICO</p>
      <li><a href="assets/archivo/2021/PROGRAMA-ANUAL-DE-DESARROLLO-ARCHIVISTICO-2021.pdf" target="_blank">PADA 2021</a></li>
      </ul>
    </div>

  </div>

</div>